import { render, staticRenderFns } from "./Serve.vue?vue&type=template&id=6752536f&"
import script from "./Serve.vue?vue&type=script&lang=js&"
export * from "./Serve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports